export default "__VITE_ASSET__CPtgpErK__"